import emojiRegex from "emoji-regex";

/**
 * Extracts emoji information from an HTML string
 *
 * How it works:
 * 1. Strips HTML tags from the input string
 * 2. Identifies emojis using the emoji-regex package
 * 3. Determines if the message contains only emojis (1-3 emojis)
 * 4. Returns emoji status and appropriate class name
 *
 * @param htmlString - The HTML string to analyze
 * @returns Object containing emoji status and class name
 */
export function extractEmojiFromMessage(htmlString?: string) {
  if (!htmlString || !htmlString.length) {
    return {
      isEmojiOnlyMessage: false,
      emojiClassName: undefined,
    };
  }

  // Get the emoji regex pattern from the emoji-regex package
  const regex = emojiRegex();

  // strip the html string from html tags
  const cleanText = htmlString.replace(/<[^>]*>/g, "");

  // Find all emojis in the text
  const matches = cleanText.match(regex) || [];

  // Count the emojis
  const emojiCount = matches.length;

  // If we found no emojis, it's not an emoji-only message
  if (emojiCount === 0) {
    return {
      isEmojiOnlyMessage: false,
      emojiClassName: undefined,
    };
  }

  // Check if the text consists only of emojis
  // We do this by removing all emoji characters and checking if anything remains
  const nonEmojiText = cleanText.replace(regex, "").trim();
  const isEmojiOnly = nonEmojiText.length === 0 && emojiCount > 0;

  // Determine if we should apply special styling (only emojis and between 1-3 emojis)
  const isEmojiOnlyMessage = isEmojiOnly && emojiCount > 0 && emojiCount <= 3;

  // Determine the appropriate class name based on emoji count
  let emojiClassName;
  if (isEmojiOnlyMessage) {
    if (emojiCount === 1) {
      emojiClassName = "emoji-only-1";
    } else if (emojiCount === 2) {
      emojiClassName = "emoji-only-2";
    } else if (emojiCount === 3) {
      emojiClassName = "emoji-only-3";
    } else {
      emojiClassName = "";
    }
  }

  return {
    isEmojiOnlyMessage,
    emojiClassName,
  };
}
